// extracted by mini-css-extract-plugin
export default {"container":"ReadyMadeSection-module__container__ODECk","text":"ReadyMadeSection-module__text__mr4Jw"};